module.exports = __webpack_public_path__ + "img/red-square-table-3.918e1da8.png";